module.exports = "<shop-app-signup [isSetting]=\"true\"></shop-app-signup>\r\n"